var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-layout[data-v-9ea40744] {\n  background-image: url(" + escape(require("@/assets/images/NTAK_Home_bg.svg")) + ");\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-size: cover;\n}\n.ant-layout-header[data-v-9ea40744] {\n  background: transparent;\n}\n@media (max-width: 576px) {\n.ant-layout-header[data-v-9ea40744] {\n      padding: 0 36px;\n}\n}\n", ""]);

// exports
